export default "__VITE_ASSET__Cvv2mzF4__"